import {
  Activity,
  BarChart3,
  Brain,
  Cloud,
  Code,
  Database,
  Layers,
  Server,
  Zap,
} from "lucide-react";

import { Link } from "wouter";

function Service() {
  const services = [
    {
      icon: Activity,
      title: "Apache Kafka",
      slug: "apache-kafka",
      description:
        "Build scalable, fault-tolerant real-time data streaming applications to power your business.",
    },
    {
      icon: Zap,
      title: "Apache Flink",
      slug: "apache-flink",
      description:
        "Process data streams at lightning speed with advanced analytics.",
    },
    {
      icon: Cloud,
      title: "Confluent Cloud",
      slug: "confluent-cloud",
      description:
        "Fully managed Kafka platform with enterprise-grade reliability.",
    },
    {
      icon: Code,
      title: "Full Stack Development",
      slug: "full-stack-development",
      description:
        "End-to-end software solutions tailored to business needs.",
    },
    {
      icon: Database,
      title: "Fivetran",
      slug: "fivetran",
      description:
        "Automate your data pipelines effortlessly with seamless connectors.",
    },
    {
      icon: Brain,
      title: "AI / Machine Learning",
      slug: "ai-ml",
      description:
        "Leverage AI and ML to predict trends and automate decisions.",
    },

    // NEW SERVICES
    {
      icon: Layers,
      title: "Databricks",
      slug: "databricks",
      description:
        "Build modern lakehouse architectures for big data engineering, analytics, AI, and machine learning.",
    },
    {
      icon: BarChart3,
      title: "Snowflake",
      slug: "snowflake",
      description:
        "Cloud data platform for scalable data warehousing, analytics, data sharing, and AI workloads.",
    },
    {
      icon: Server,
      title: "Microsoft Fabric",
      slug: "microsoft-fabric",
      description:
        "An integrated platform for data engineering, analytics, AI, and business intelligence."
    },
  ];

  return (
    <section className="py-20 text-center">
      <div className="mx-auto max-w-4xl px-4">
        <h2 className="mb-3 text-center text-3xl font-bold text-gray-800 sm:text-4xl">
          Our Core Services
        </h2>

        <p className="mx-auto mb-12 max-w-3xl text-center text-gray-500">
          Cutting-edge technology solutions designed to transform your
          business.
        </p>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <Link key={service.slug} href={`/services/${service.slug}`}>
              <a className="group block cursor-pointer rounded-xl bg-white p-6 shadow-md transition duration-300 hover:-translate-y-1 hover:shadow-xl">
                {/* Icon */}
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-orange-500 transition duration-300 group-hover:bg-orange-600">
                  <service.icon className="text-white" size={24} />
                </div>

                {/* Title */}
                <h3 className="mb-2 text-xl font-semibold text-gray-800">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="mb-6 text-sm text-gray-500">
                  {service.description}
                </p>

                {/* Learn More */}
                <span className="inline-flex items-center text-sm font-semibold text-orange-500">
                  Learn More →
                </span>
              </a>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Service;